import React from 'react';
import { TicketIcon } from '@heroicons/react/outline';

import { Fare } from '../api/fare';

import Card, { CardBody } from './Card';
import FareListEntry from './FareListEntry';

function EmptyCard(): JSX.Element {
  return (
    <div className="flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
      <div className="space-y-1 text-center">
        <TicketIcon className="mx-auto h-12 w-12 text-gray-400" />
        <h2 className="text-lg leading-6 font-medium text-gray-900">
          No fares loaded
        </h2>
        <p className="text-sm text-gray-600">
          Find the nearest location to reload your card on the{' '}
          <a
            href="https://www.crtm.es/billetes-y-tarifas/tarjeta-transporte-publico/como-se-utiliza.aspx"
            className="font-medium text-indigo-600 hover:text-indigo-500"
          >
            CRTM website
          </a>
          .
        </p>
      </div>
    </div>
  );
}

type FareListProps = {
  fares: Fare[];
};

function FareList({ fares }: FareListProps): JSX.Element {
  if (fares.length === 0) {
    return <EmptyCard />;
  }

  return (
    <Card>
      <CardBody pad={false}>
        <ul className="divide-y divide-gray-200">
          {fares.map((fare) => (
            <FareListEntry key={fare.id} fare={fare} />
          ))}
        </ul>
      </CardBody>
    </Card>
  );
}

export default FareList;
